import { db } from "../Config";

// función asincrona de fetch ordenes
export const fetchListas = (empresaId) => {
  return new Promise((resolve, reject) => {
    let listasRef = db
      .collection("configuraciones_generales")
      .doc("bancos_monederos");
    let listas = {};
    let items = {};
    listasRef
      //.where("empresaId", "==", empresaId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          //las listas estan dentro del objeto map items
          items = doc.data().items;
          listas = {
            bancos: items.bancos,
            monederos: items.monederos,
          };
          resolve(listas);
        }
      })

      // .then((querySnapshot) => {
      //   querySnapshot.forEach((doc) => {
      //     listas = {
      //       bancos: doc.data().bancos,
      //       monederos: doc.data().monederos,
      //     };
      //   });
      //   resolve(listas);
      // })
      .catch((err) => reject(err));
  });
};
